import React, { useEffect, useState } from "react"
import { Button, Modal, Table2 } from "components";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { getFAQList, editFAQ, createFAQ, deleteFAQ } from "./actions";
import { TextArea } from "components/fields";
import { useParams } from "react-router";
import * as Yup from "yup";

import "../modals.scss";


export const QATable = ({ data, setEdit, onDelete }) => {


	if(!data.length) {
		return null
	}

	const columns = [{
		accessor: 'id',
		Header: 'ID',
	}, {
		accessor: 'question',
		Header: 'Question',
	}, {
		accessor: 'options',
		Header: '',
		disableSortBy: true,
		Cell: ({ row }) => (
			<div className="widget-table-options">
				<Button size="large" variant="secondary" className="mr-3" onClick={() => setEdit(row.original.uniqid)}>
					Edit
				</Button>
				<Button size="large" onClick={() => onDelete(row.original.uniqid)}>
					Delete
				</Button>
			</div>
		)
	}];

	return <Table2 data={data} columns={columns} notFound="No questions" />
}


const validationSchema = Yup.object().shape({
	question: Yup.string().required('Question is required'),
	answer: Yup.string().required('Answer is required')
});

const QAForm = ({ onEdit, onCreate, cancel, id, list }) => {

	if(!id) {
		return null
	}

	let current = list.find((data) => data.uniqid === id);

	const initialValues = {
		question: current ? current.question : "",
		answer: current ? current.answer : "",
	};

	const onSubmit = (values) => {
		if(id === -1) {
			onCreate(values)
		} else {
			onEdit(values)
		}
	}

	let form = useFormik({ validationSchema, enableReinitialize: true, initialValues, onSubmit });

	return <form className="custom-widget mb-0 pb-3" onSubmit={form.handleSubmit}>

		<div className="custom-widget-body flex-column">
			<TextArea name="question" label="Question" placeholder="Question" {...form} />
			<TextArea name="answer" label="Answer" placeholder="Answer" {...form} />
		</div>

		<div className="custom-widget-footer">
			<Button className="mr-3" size="large" variant="secondary" onClick={cancel}>
				Cancel
			</Button>
			<Button type="submit" size="large">
				Save
			</Button>
		</div>

	</form>
}


export default ({ setModal, modal }) => {

	const [edit, setEdit] = useState(null);
	const [list, setList] = useState([]);
	const dispatch = useDispatch();
	const { id } = useParams();

	const fetchList = () => {
		dispatch(getFAQList(id))
			.then(res => {
				setList(res.data.faq);
				setEdit(null);
			})
	}

	useEffect(() => {
		fetchList();
	}, [])

	const onDelete = (faq) => {
		dispatch(deleteFAQ({ id, faq }))
			.then(() => {
				fetchList();
			})
	}

	const onEdit = ({ question, answer }) => {
		dispatch(editFAQ({ question, answer, faq: edit, id }))
			.then(() => {
				setEdit(null);
				fetchList();
			})
	}

	const onCreate = ({ question, answer }) => {
		dispatch(createFAQ({ question, answer, id }))
			.then(() => {
				fetchList();
			})
	}

	return <>
		<Button className="w-100" size="large" variant="secondary" iconName="plus" iconPosition="left" onClick={() => setModal(true)}>Product QA</Button>

		<div className="paylixecommerce-note mb-3">
			Set questions and answers to the most popular user questions for your product
		</div>

		<Modal open={modal} closeModal={() => setModal(false)} className="widget-modal">

			<div className="paylixecommerce-modal-header">
				{edit === -1 ? "New QA" : edit ? "Edit QA" : "Manage QA"}
			</div>

			<div className="paylixecommerce-modal-body">

				<div style={{
					background: "var(--white)",
					padding: "1rem",
					borderRadius: "0.5rem",
					marginBottom: "1.5rem",
					border: "1px solid var(--black1)",
					fontSize: ".8rem",
					display: (edit !== -1 && !edit) ? "flex" : "none",
				}}>
					<div>
						You can add Questions & Answers for your products. <br/>
						These will be shown on the product page on our marketplace for customers to review.
					</div>
				</div>

				<QAForm
					onEdit={onEdit}
					onCreate={onCreate}
					id={edit}
					cancel={() => setEdit(null)}
					list={list}
				/>

				<QATable data={list} setEdit={setEdit} onDelete={onDelete} />
			</div>

			<div className="paylixecommerce-modal-footer">

				<div className="widget-footer">
					<Button variant="secondary" size="large" className="mr-3" onClick={() => setModal(false)}>Close</Button>
					{(edit || edit === -1) ? null :
						<Button size="large" onClick={() => setEdit(-1)}>
							Add QA
						</Button>
					}
				</div>

			</div>

		</Modal>
	</>

}
